import React from 'react';
import { ErrorBoundary } from '@avon/component-library';
import cookies from 'react-cookies';
import { makeBaseApi } from '../api';
import getUrlParams from '../getUrlParams';
import GoogleTagManager from '../../analytics/GTM';
import gAPi from '../api/globalApi';
import ReLoginToast from '../../components/ReLoginToast';

const withCallApi = (Element, search, props, globalApi) => {
  if (globalApi) {
    const callApi = gAPi({
      // eslint-disable-next-line no-underscore-dangle
      domain: window._env_.REACT_APP_API_URL,
    });
    const errorCodeCallApi = makeBaseApi({
      // eslint-disable-next-line no-underscore-dangle
      domain: window._env_.REACT_APP_API_URL,
      market: window.location.host.endsWith('.ru') ? 'RU' : 'UK',
      device: 'mobile',
      language: window.location.host.endsWith('.ru') ? 'ru' : 'en',
      channel: 'mra',
    });

    const openError = (error) => {
      sessionStorage.clear();
      localStorage.clear();
      sessionStorage.setItem('reLoginMessage', JSON.stringify(error));
      window.location.reload();
    };

    return (
      <ErrorBoundary openError={openError} callApi={errorCodeCallApi} language={cookies.load('langCd')}>
        <GoogleTagManager
          gtmId="GTM-WW676QK"
          // eslint-disable-next-line no-underscore-dangle
          domain={window._env_.REACT_APP_API_URL}
          market={cookies.load('mrktCd')}
          device="mobile"
          language={cookies.load('langCd')}
          channel="mra"
        />
        <Element {...props} callApi={callApi} />
        <ReLoginToast />
      </ErrorBoundary>
    );
  }
  const {
    market, device, language, channel, accessToken, refreshToken,
  } = getUrlParams(search);

  const callApi = makeBaseApi({
    // eslint-disable-next-line no-underscore-dangle
    domain: window._env_.REACT_APP_API_URL,
    market,
    device,
    language,
    channel,
    accessToken,
    refreshToken,
  });
  return (
    <ErrorBoundary callApi={callApi} language={language}>
      <GoogleTagManager
        gtmId="GTM-WW676QK"
        // eslint-disable-next-line no-underscore-dangle
        domain={window._env_.REACT_APP_API_URL}
        market={market}
        device={device}
        language={language}
        channel={channel}
      />
      <Element {...props} callApi={callApi} language={language} market={market} />
    </ErrorBoundary>
  );
};

export default withCallApi;
